const initialContextStore = {
        step: 1,
        formData: {            
            name:'',
            country: '',
            postalCode: '',
            city: '',
            city2: '',
            branch: '',
            streetAddress: '',
            billingAddress: '',
            companyName:'',
            contactName: '',
            contactPhone: '',
        },
        isSubmitting: false,
    }

export default initialContextStore